"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const Pager_1 = require("./Pager");
const PaginationConfiguration_1 = require("./PaginationConfiguration");
require("./index.scss");
const className = 'pagination';
const Pagination = (props) => {
    const { total, pageTotal, pagination, maxPageSize, setPage, setPageSize } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Pager_1.Pager, { total: total, pagination: pagination, setPage: setPage }),
        react_1.default.createElement(PaginationConfiguration_1.PaginationConfiguration, { total: total, pageTotal: pageTotal, pagination: pagination, maxPageSize: maxPageSize, setPageSize: setPageSize })));
};
exports.Pagination = Pagination;
//# sourceMappingURL=index.js.map